import React from 'react';
import SelectedLeadPopup from './SelectedLeadPopup';
import SelectedContactPopup from './SelectedContactPopup';
import SelectedRegisteredPopup from './SelectedRegisteredPopup';
import SelectedEnquiryPopup from '../BuyLeads/Enquiry/SelectedEnquiryPopup';

const SelectedPopup = (props) => {
  const { itemType } = props;

  if (itemType === 'lead') {
    return <SelectedLeadPopup {...props} />;
  } 
  else if (itemType === 'contact') {
    return <SelectedContactPopup {...props} />;
  } else if (itemType === 'registeredSeller') {
    return <SelectedRegisteredPopup {...props} />;
  } else if (itemType === 'enquiry') {
    return <SelectedEnquiryPopup {...props}/>;
  }
  else {
    return null;
  }
};

export default SelectedPopup;
